var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"admin-dashboard-analytics"}},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full lg:w-1/2 mb-base"},[_c('h2',[_vm._v(_vm._s(_vm.$t('Dashboard')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }